export enum MFAStatus {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
}
